import { isRevenueNavigationPath } from './isRevenueEnvironment';

export { isRevenueNavigationPath };

/** Revenue app stores the active Revenue tenant id here (same origin as One ID full-screen Zuora AI). */
export const ZREVENUE_TENANT_STORAGE_KEY = 'ZRevenue_TenantID';

const ZUORA_AI_APP_PATH = '/platform/apps/zuora-ai';

function isZuoraAiFullScreenPath(pathname: string): boolean {
  return pathname.includes(ZUORA_AI_APP_PATH);
}

/**
 * Tenant id for Zuora AI Amplitude events (AI-871).
 * Uses Revenue localStorage tenant on Revenue paths; on same-origin Zuora AI full screen,
 * prefers ZRevenue_TenantID when set so events match the Revenue session that opened full screen.
 * Otherwise uses the billing / platform identity tenant id.
 */
export function getAmplitudeAITenantId(
  billingTenantId: string | null | undefined,
): string {
  if (typeof window === 'undefined') {
    return billingTenantId ?? '';
  }
  const revenueTenantId = window.localStorage.getItem(
    ZREVENUE_TENANT_STORAGE_KEY,
  );

  if (isRevenueNavigationPath(window.location.pathname)) {
    return revenueTenantId || billingTenantId || '';
  }
  if (isZuoraAiFullScreenPath(window.location.pathname)) {
    return revenueTenantId || billingTenantId || '';
  }
  return billingTenantId || '';
}
